import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: "http://localhost:8080/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers.Language = localStorage.getItem("language") || "en";
      config.headers.Language = window.selectedLanguage || "en";
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
